import React, { Component } from 'react'
import { connect } from 'react-redux'

const footerContainer = (ComposedComponent) => {
    class FooterContainer extends Component {
        render () {
            return (
                <ComposedComponent {...this.props} />
            )
        }
    }
    const mapStateToProps = ({
        langs: { indexLang },
    }) => ({
        indexLang,
    })
    return connect(mapStateToProps)(FooterContainer)
}

export default footerContainer
